export const locale = {
    lang: 'en',
    data: {
        'serviceName': 'Service',
        'balance': 'Balance',
        'expirationDate': 'Expiration date',
        'addedAt': 'Added at'
    }
};
